import { Banner } from '../components/Banner'
import { Skills } from '../components/Skills'
import { Projects } from '../components/Projects'
import { Contact } from '../components/Contact'
import Qualification from '../components/Qualification'
import Carousel from '../components/Carousel'
import Awards from '../components/Awards/Awards'


const Home = () => {
  return (
    <>
        <Banner/>
        <Skills/>
        <Qualification/>
        <Projects/>
        <Awards/>
        <Carousel/>
        <Contact />
        
    </>
  )
}

export default Home